import React, { useEffect, useState } from "react";
import LayoutNew from "../components/shared/LayoutNew";
import { Form, Button, InputGroup, ButtonGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import giftbg from "../assets/images/temu-history-box.gif";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
const PromoCode = () => {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const userCoins = useContextSelector(AuthContext, (ctx) => ctx.userCoins);
  const {
    formState: { errors },
  } = useForm({});

  const navigate = useNavigate();

  return (
    <LayoutNew>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xlinkHref="http://www.w3.org/1999/xlink"
        style={{ position: `absolute`, width: `0`, height: `0` }}
      >
        <defs>
          <symbol
            xlinkHref="http://www.w3.org/1999/xlink"
            viewBox="0 0 44 44"
            id="left"
          >
            <title>Operation Icons Copy 4</title>
            <defs>
              <path id="left_a" d="M-129-845h24v24h-24z"></path>
            </defs>
            <clipPath id="left_b">
              <use xlinkHref="#left_a" overflow="visible"></use>
            </clipPath>
            <g clipPath="url(#left_b)">
              <defs>
                <path id="left_c" d="M-903-949H947V996H-903z"></path>
              </defs>
              <clipPath id="left_d">
                <use xlinkHref="#left_c" overflow="visible"></use>
              </clipPath>
            </g>
            <path d="M16.247 21.399L28.48 9.166l2.121 2.121-10.118 10.119 10.118 10.118-2.121 2.121-12.233-12.233.007-.006z"></path>
          </symbol>
        </defs>
      </svg>
      <div
        id="mc-animate-container"
        class="v-base v-detail-base fade-enter-done"
      >
        <div class="temu-history-wrapper">
          <div class="mc-header-wrap">
            <div
              id="mc-header"
              class="mc-navbar-blue mc-temuTicket mc-default-header am-navbar am-navbar-light"
            >
              <div class="am-navbar-left" role="button">
                <span class="am-navbar-left-content">
                  <span class="return_icon" onClick={() => navigate(-1)}>
                    <svg class="am-icon am-icon-left am-icon-lg">
                      <use xlinkHref="#left"></use>
                    </svg>
                  </span>
                </span>
              </div>
              <div class="am-navbar-title">Promo Code</div>
              <div class="am-navbar-right"></div>
            </div>
            <div class="am-whitespace am-whitespace-sm mc-whitespace"></div>
          </div>
          <div class="temu-history-wrap">
            <div class="history-header">
              <div class="header-img">
                <img src={giftbg} alt="" />
              </div>
              <div class="header-amount">
                <div class="amount-title">Total Claimed Amount</div>
                <div class="amount-balance-common amount-item">
                  <span class="currency ">৳</span>
                  &nbsp;
                  <span class="number-mc undefined">
                    <div class="wysiwyg">
                      0. <label class="small">00</label>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div class="history-list">
              <div class="list-wrapper">
                <ul class="scroll-inner-container">
                  <li>
                    <div class="list-item">
                      <div class="item-info">
                        <div class="info-title">Date</div>
                        <div class="info-txt">2025/06/11 23:31:35</div>
                      </div>
                      <div class="item-info">
                        <div class="info-title">Ticket name</div>
                        <div class="info-txt">শেয়ার করে জিতুন</div>
                      </div>
                      <div class="item-info">
                        <div class="info-title">Condition</div>
                        <div class="info-txt">Ticket Expired</div>
                      </div>
                      <div class="item-info">
                        <div class="info-title">Added amount</div>
                        <div class="info-txt">-970.85</div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="list-item">
                      <div class="item-info">
                        <div class="info-title">Date</div>
                        <div class="info-txt">2025/06/04 23:54:55</div>
                      </div>
                      <div class="item-info">
                        <div class="info-title">Ticket name</div>
                        <div class="info-txt">শেয়ার করে জিতুন</div>
                      </div>
                      <div class="item-info">
                        <div class="info-title">Condition</div>
                        <div class="info-txt">Claim Initial Points</div>
                      </div>
                      <div class="item-info">
                        <div class="info-title">Added amount</div>
                        <div class="info-txt">+ 970.85</div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="pullup-wrapper"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutNew>
  );
};

export default PromoCode;
